/**
 * 添加开普勒购物车
 * 接口文档：http://legos.wq.jd.com/ci.php/api/#id=25184
 */
export default function addCartToKPL(opts = { sku: '' }) {
  console.log(opts.sku);
  if (opts.sku && window.AddcartToolObj && window.AddcartToolObj.addCart) {
    window.AddcartToolObj.addCart({
      skuId: opts.sku,
      source: 'm',
      isWq: false,
      actId: 0,
      sucFun: rst => {
        if (typeof rst === 'string') {
          rst = JSON.parse(rst);
        }
        const isSueecss = rst.errId === '0';
        console.log('ok,接口请求成功,不一定指的加车成功,加车成功需要看返回码', isSueecss, rst);
        // 添加成功
        opts.addSuccess && opts.addSuccess(isSueecss, rst, opts);
      },
      failFun: () => {
        console.log('fail', arguments);
        // 添加失败
        opts.addFail && opts.addFail(false, {}, opts);
      }
    });
  }
}
